<template>
  <el-input
    :placeholder="placeholder"
    size="small"
    v-model="value"
    @keyup.enter.native="$emit('search', value)">
    <i slot="suffix" class="el-input__icon el-icon-search" @click="$emit('search', value)"></i>
  </el-input>
</template>

<script>
export default {
  name: 'input-search',
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索内容'
    }
  },
  data () {
    return {
      value: ''
    }
  }
}
</script>

<style scoped>
  .el-input--small {
    width: 220px;
  }
  .el-input__icon {
    font-size: 16px;
    height: 32px;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Input/InputSearch.vue